import { render, staticRenderFns } from "./bookConfirmOrder.vue?vue&type=template&id=37baab4a&scoped=true"
import script from "./bookConfirmOrder.vue?vue&type=script&lang=js"
export * from "./bookConfirmOrder.vue?vue&type=script&lang=js"
import style0 from "./bookConfirmOrder.vue?vue&type=style&index=0&id=37baab4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37baab4a",
  null
  
)

export default component.exports